/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StatusCard_company = {
    readonly certificatesStatus: {
        readonly secondaryCategoryStatuses: ReadonlyArray<{
            readonly secondaryCategory: {
                readonly name: string;
                readonly uuid: string | null;
            } | null;
            readonly totals: {
                readonly available: number;
                readonly expired: number;
                readonly expiringSoon: number;
                readonly incomplete: number;
            };
        }>;
    };
    readonly simulatorCompliance: {
        readonly activeUsers: number;
        readonly compliantUsers: number;
        readonly uncompliantUsers: number;
    };
    readonly documentStatus: {
        readonly available: number;
        readonly expired: number;
        readonly expiringSoon: number;
        readonly incomplete: number;
    };
    readonly backgroundCheckStatus: {
        readonly available: number;
        readonly expired: number;
        readonly expiringSoon: number;
        readonly incomplete: number;
    };
    readonly " $refType": "StatusCard_company";
};
export type StatusCard_company$data = StatusCard_company;
export type StatusCard_company$key = {
    readonly " $data"?: StatusCard_company$data;
    readonly " $fragmentRefs": FragmentRefs<"StatusCard_company">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "available",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "expired",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "expiringSoon",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "incomplete",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "StatusCard_company",
        "type": "Company",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "certificatesStatus",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanyCertificateStatus",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "secondaryCategoryStatuses",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SecondaryCategoryCertificateStatus",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "secondaryCategory",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "SecondaryCategory",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "name",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "uuid",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "totals",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ExpiryStatus",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "simulatorCompliance",
                "storageKey": null,
                "args": null,
                "concreteType": "SimulatorCompliance",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "activeUsers",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "compliantUsers",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "uncompliantUsers",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "documentStatus",
                "storageKey": null,
                "args": null,
                "concreteType": "ExpiryStatus",
                "plural": false,
                "selections": (v0 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "backgroundCheckStatus",
                "storageKey": null,
                "args": null,
                "concreteType": "ExpiryStatus",
                "plural": false,
                "selections": (v0 /*: any*/)
            }
        ]
    } as any;
})();
(node as any).hash = '4b0bfe10d63af85c8f41a9f3bdb9a26d';
export default node;
